export default {
    "baskets": {
        "baskets": "Baskets",
        "addToBasket": "Add to basket",
        "removeFromBasket": "Remove from basket",
        "removeFromAllBaskets": "Remove from all baskets",
        "removeFromAllBasketsConfirmation": "Are you sure you want to remove this result from these baskets: {baskets}?",
        "basketAlreadyExists": "A basket with that name already exists. Would you like to replace it?",
        "noBasket": "You have not yet added a document to a basket...",
        "createBasket": "Create Basket",
        "manageBaskets": "Manage Baskets",
        "delete": "Delete this basket"
    },

    "editBasket": {
        "title": "Basket",
        "name": "Name"
    },

    "manageBaskets": {
        "title": "Manage Baskets",
        "save": "Save",
        "reorder": "Reorder",
        "remove": "Remove",
        "removeAll": "Remove all",
        "name": "Name",
        "tooltip": {
            "export": "Export this basket"
        }
    },

    "selectBasket": {
        "title": "Select Basket",
        "newBasket": "New basket..."
    }
};
